import { useState } from "react";
import { ServiceIntroMain, ServiceCtaSection } from "@/components/service-provide";

const ServiceMessaging = () => {
  const [activeTab, setActiveTab] = useState<keyof typeof tabData>("SMS");

  // message 데이터
  const tabData = {
    SMS: {
      title: "단문(SMS)",
      desc: "본인확인, 인증번호, 결제 알림 등 짧은 메시지",
      tags: ["정보성 알림", "택배, 결제 알림 등 짧은 메시지"],
      phoneImage: "/img/service-provide/messaging/message_01.png",
    },
    LMS: {
      title: "장문(LMS)",
      desc: "상세한 정보 전달이 필요한 긴 텍스트 메시지",
      tags: ["뉴스레터", "상세 공지사항"],
      phoneImage: "/img/service-provide/messaging/message_02.png",
    },
    MMS: {
      title: "멀티미디어(MMS)",
      desc: "이미지와 함께 전달하는 풍성한 메시지",
      tags: ["이벤트 홍보", "이미지 포함 가이드"],
      phoneImage: "/img/service-provide/messaging/message_03.png",
    },
  };

  // RCS 템플릿 데이터
  const rcsTemplates = [
    {
      image: "/img/service-provide/messaging/rcs_01.png",
      title: "텍스트 템플릿-단문",
      subtitle: "(정보성)",
    },
    {
      image: "/img/service-provide/messaging/rcs_02.png",
      title: "텍스트 템플릿-장문",
      subtitle: "(광고성)",
    },
    {
      image: "/img/service-provide/messaging/rcs_03.png",
      title: "이미지 템플릿",
      subtitle: "(광고성)",
    },
  ];

  return (
    <>
      <ServiceIntroMain />

      <div className="flex flex-col items-center justify-center gap-20 pt-[3.5rem]">
        {/* 1. 문자 메시징 섹션 */}
        <section className="w-full">
          {/* 컨테이너*/}
          <div className="max-w-container mx-auto px-100 about:px-0">
            {/* 메인 레이아웃*/}
            <div className="flex flex-col about:flex-row justify-between items-center about:items-start gap-12 lg:gap-20 px-[2rem] wide:px-0">
              {/* [좌측 영역] */}
              <div className="flex-1 about:flex-2 flex flex-col items-center about:items-start w-full min-w-0 text-center about:text-left">
                {/* 상단 타이틀 & 설명글 */}
                <div className="w-full mb-12 about:mb-16">
                  <h2 className="flex flex-col about:flex-row items-center about:items-end font-bold mb-8 ">
                    <span className="text-[3.5rem] md:text-[4.2rem] text-[#2563EB] leading-none shrink-0">
                      문자
                    </span>
                    <div className="flex flex-col mt-4 about:mt-0 about:ml-8 shrink-0">
                      <div className="flex justify-center about:justify-start gap-6 text-[1.4rem] text-gray-400 font-medium mb-2 uppercase">
                        <span>sms,lms,mms</span>
                      </div>
                      <span className="text-[2rem] md:text-[2.4rem] text-std-black leading-none">
                        단문 메시지부터 장문, 멀티미디어까지
                      </span>
                    </div>
                  </h2>

                  <p className="text-[1.6rem] md:text-[2rem] text-gray-600 leading-relaxed break-keep">
                    단순 메시지를 넘어 차세대 양방향 소통을 지원하며,{" "}
                    <br className="hidden about:block" />
                    단문부터 멀티미디어까지 비즈니스에 최적화된 모든 문자 전송을 책임지는 통합
                    메시징 솔루션
                  </p>
                </div>

                {/* [모바일] 이미지 영역*/}
                <div className="flex about:hidden flex-col items-center w-full mb-[rem]">
                  <div className="relative w-full max-w-[320px]">
                    <img
                      src={tabData[activeTab].phoneImage}
                      alt={activeTab}
                      className="w-full h-auto"
                    />
                  </div>
                  <div className="flex flex-wrap gap-4 justify-center">
                    {tabData[activeTab].tags.map((tag, idx) => (
                      <span
                        key={idx}
                        className="px-8 py-3 bg-[#2563EB] text-white rounded-full text-[1.6rem] font-medium shadow-md"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

                {/* [하단] 탭 메뉴 버튼 */}
                <div className="flex flex-col w-full max-w-[420px] bg-[#F1F3F7] rounded-3xl overflow-hidden shrink-0 mt-[2rem] mx-auto about:mx-0">
                  {(Object.keys(tabData) as Array<keyof typeof tabData>).map(key => (
                    <button
                      key={key}
                      onClick={() => setActiveTab(key)}
                      className={`flex items-center justify-between px-10 py-10 text-[2rem] md:text-[2.2rem] font-bold transition-all border-b border-gray-200 last:border-none ${
                        activeTab === key
                          ? "bg-std-blue text-white"
                          : "text-gray-500 hover:bg-gray-200"
                      }`}
                    >
                      <span>{tabData[key].title}</span>
                      <span className="material-icons-round">arrow_forward</span>
                    </button>
                  ))}
                </div>
              </div>

              {/* [우측 영역]  */}
              <div className="hidden about:flex flex-col items-center shrink-0 w-[450px]">
                <div className="relative w-full max-w-[400px] mb-12">
                  <img
                    src={tabData[activeTab].phoneImage}
                    alt={activeTab}
                    className="w-full h-auto"
                  />
                </div>
                <div className="flex flex-wrap gap-4 justify-center">
                  {tabData[activeTab].tags.map((tag, idx) => (
                    <span
                      key={idx}
                      className="px-10 py-4 bg-[#2563EB] text-white rounded-full text-[1.8rem] font-medium shadow-md"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 2. 알림톡/브랜드메시지 섹션 */}
        <section className="w-full bg-[#EEF1F4] py-[3.3rem] px-5 about:px-0 mx-auto">
          <div className="mx-auto max-w-container px-[2rem] wide:px-0">
            {/* (1) 알림톡 섹션 */}
            <div className="mb-28">
              <div className="grid grid-cols-1 about:grid-cols-2 gap-12 about:gap-2 items-center">
                <div className="flex flex-col gap-10">
                  <h2 className="flex flex-col wide:flex-row items-start wide:items-end font-bold gap-4 mb-8 text-left">
                    <span className="text-[3.5rem] md:text-[4.2rem] text-std-purple leading-none whitespace-nowrap">
                      알림톡
                    </span>
                    <span className="text-[2rem] md:text-[2.4rem] text-std-black leading-tight break-keep">
                      카카오톡 기반 정보성 메시지
                    </span>
                  </h2>

                  <div className="flex about:hidden justify-center w-full">
                    <img
                      src="/img/alimtalk/alimtalk_top_02.png"
                      alt="알림톡 예시"
                      className="w-full max-w-[500px] h-auto object-contain"
                    />
                  </div>

                  <div className="flex flex-col gap-6">
                    <div className="bg-white p-10 rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.05)] border border-gray-100 relative overflow-hidden">
                      <div className="flex items-center gap-4 mb-4 ml-2">
                        <span className="material-icons-round text-[2.6rem] text-std-purple p-2 rounded-xl">
                          featured_play_list
                        </span>
                        <h4 className="text-[2.4rem] font-bold text-std-black">주요 특징</h4>
                      </div>
                      <p className="text-[1.6rem] md:text-[1.8rem] text-gray-700 leading-[1.6] ml-2">
                        주문, 배송, 결제 등 고객이 꼭 받아야 하는 필수 정보를 카카오톡으로
                        전송합니다. <br />
                        별도의 <strong>친구 추가 절차 없이</strong> 전화번호 기반으로 발송
                        가능합니다.
                      </p>
                    </div>

                    {/* <div className="bg-white p-10 rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.05)] border border-gray-100 relative overflow-hidden">
                      <div className="absolute left-0 top-0 bottom-0 w-2 bg-std-purple"></div>
                      <div className="flex items-center gap-4 mb-4 ml-2">
                        <span className="material-icons-round text-[2.6rem] text-std-purple p-2 rounded-xl">
                          trending_up
                        </span>
                        <h4 className="text-[2.4rem] font-bold text-std-black">기대 효과</h4>
                      </div>
                      <ul className="text-[1.6rem] md:text-[1.8rem] text-gray-700 leading-[1.3] ml-2 space-y-3 list-disc list-inside marker:text-std-purple">
                        <li>스팸 차단율이 낮고 도달율이 매우 높아집니다.</li>
                        <li>카카오 인증 마크 부여로 기업 신뢰도가 상승합니다.</li>
                        <li>SMS 대비 저렴한 비용으로 상세 내용을 전달할 수 있습니다.</li>
                      </ul>
                    </div> */}

                    <div className="bg-white p-10 rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.05)] border border-gray-100 relative overflow-hidden">
                      <div className="flex items-center gap-4 mb-10 ml-2">
                        <span className="material-icons-round text-[2.6rem] text-std-purple p-2 rounded-xl">
                          trending_up
                        </span>
                        <h4 className="text-[2.4rem] font-bold text-std-black">기대 효과</h4>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-0 text-center">
                        <div className="flex flex-col items-center justify-center px-4 md:border-r md:border-gray-200">
                          <div className="w-[80px] h-[80px] bg-[#EEF1F4] rounded-full flex items-center justify-center mb-6">
                            <span className="material-icons-round text-[3.5rem] text-std-purple">
                              shield
                            </span>
                          </div>
                          <p className="text-[1.6rem] font-medium text-gray-800 leading-snug break-keep">
                            스팸 차단율 <span className="text-std-purple font-medium">↓</span>
                            <br />
                            메시지 도달율 <span className="text-std-purple font-medium">↑</span>
                          </p>
                        </div>

                        <div className="flex flex-col items-center justify-center px-4 md:border-r md:border-gray-200">
                          <div className="w-[80px] h-[80px] bg-[#EEF1F4] rounded-full flex items-center justify-center mb-6">
                            <span className="material-icons-round text-[3.5rem] text-std-purple">
                              verified
                            </span>
                          </div>
                          <p className="text-[1.6rem] font-medium text-gray-800 leading-snug break-keep">
                            카카오 인증 마크 부여로
                            <br />
                            기업 신뢰도 <span className="text-std-purple font-medium">↑</span>
                          </p>
                        </div>

                        <div className="flex flex-col items-center justify-center px-4">
                          <div className="w-[80px] h-[80px] bg-[#EEF1F4] rounded-full flex items-center justify-center mb-6">
                            <span className="material-icons-round text-[3.5rem] text-std-purple">
                              account_balance_wallet
                            </span>
                          </div>
                          <p className="text-[1.6rem] font-medium text-gray-800 leading-snug break-keep">
                            SMS 대비 저렴하게
                            <br />
                            상세 내용 전달
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="hidden about:flex justify-center about:justify-end self-center">
                  <img
                    src="/img/alimtalk/alimtalk_top_02.png"
                    alt="알림톡 예시"
                    className="w-full max-w-[550px] h-auto object-contain"
                  />
                </div>
              </div>
            </div>

            {/* (2) 브랜드 메시지 영역 */}
            <div className="mb-[2rem]">
              <div className="grid grid-cols-1 about:grid-cols-2 gap-12 about:gap-2 items-center">
                <div className="hidden about:flex justify-center about:justify-start self-center">
                  <img
                    src="/img/alimtalk/alimtalk_top_01.png"
                    alt="브랜드메시지 예시"
                    className="w-full max-w-[550px] h-auto object-contain"
                  />
                </div>

                <div className="flex flex-col gap-10">
                  <h2 className="flex flex-col wide:flex-row items-start wide:items-end font-bold gap-4 mb-8 text-left">
                    <span className="text-[3.5rem] md:text-[4.2rem] text-std-purple leading-none whitespace-nowrap">
                      브랜드메시지
                    </span>
                    <span className="text-[2rem] md:text-[2.4rem] text-std-black leading-tight break-keep">
                      눈을 사로잡는 마케팅 메시지
                    </span>
                  </h2>

                  <div className="flex about:hidden justify-center w-full">
                    <img
                      src="/img/alimtalk/alimtalk_top_01.png"
                      alt="브랜드메시지 예시"
                      className="w-full max-w-[500px] h-auto object-contain"
                    />
                  </div>

                  <div className="flex flex-col gap-6">
                    <div className="bg-white p-10 rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.05)] border border-gray-100 relative overflow-hidden">
                      <div className="flex items-center gap-4 mb-4 ml-2">
                        <span className="material-icons-round text-[2.6rem] text-std-purple p-2 rounded-xl">
                          featured_play_list
                        </span>
                        <h4 className="text-[2.4rem] font-bold text-std-black">주요 특징</h4>
                      </div>
                      <p className="text-[1.6rem] md:text-[1.8rem] text-gray-700 leading-[1.6] ml-2">
                        고해상도 이미지와 동영상 등 <strong>풍부한 콘텐츠를 활용하여</strong> 마케팅
                        메시지를 전달합니다.
                      </p>
                    </div>
                    {/* <div className="bg-white p-10 rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.05)] border border-gray-100 relative overflow-hidden">
                      <div className="absolute left-0 top-0 bottom-0 w-2 bg-std-purple"></div>
                      <div className="flex items-center gap-4 mb-4 ml-2">
                        <span className="material-icons-round text-[2.6rem] text-std-purple p-2 rounded-xl">
                          trending_up
                        </span>
                        <h4 className="text-[2.4rem] font-bold text-std-black">기대 효과</h4>
                      </div>
                      <ul className="text-[1.6rem] md:text-[1.8rem] text-gray-700 leading-[1.3] ml-2 space-y-3 list-disc list-inside">
                        <li>성별, 연령, 지역 등 정교한 고객 타겟팅이 가능합니다.</li>
                        <li>개인화된 맞춤형 쿠폰 및 혜택 제공으로 전환율이 증대됩니다.</li>
                        <li>양방향 소통을 통한 고객 충성도가 강화됩니다.</li>
                      </ul>
                    </div> */}

                    <div className="bg-white p-10 rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.05)] border border-gray-100 relative overflow-hidden">
                      <div className="flex items-center gap-4 mb-10 ml-2">
                        <span className="material-icons-round text-[2.6rem] text-std-purple p-2 rounded-xl">
                          trending_up
                        </span>
                        <h4 className="text-[2.4rem] font-bold text-std-black">기대 효과</h4>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-0 text-center">
                        <div className="flex flex-col items-center justify-center px-4 md:border-r md:border-gray-200">
                          <div className="w-[80px] h-[80px] bg-[#EEF1F4] rounded-full flex items-center justify-center mb-6">
                            <span className="material-icons-round text-[3.5rem] text-std-purple">
                              ads_click
                            </span>
                          </div>
                          <p className="text-[1.6rem] font-medium text-gray-800 leading-snug break-keep">
                            성별,연령,지역 등
                            <br />
                            정교한 고객 타겟팅 가능
                          </p>
                        </div>

                        <div className="flex flex-col items-center justify-center px-4 md:border-r md:border-gray-200">
                          <div className="w-[80px] h-[80px] bg-[#EEF1F4] rounded-full flex items-center justify-center mb-6">
                            <span className="material-icons-round text-[3.5rem] text-std-purple">
                              local_activity
                            </span>
                          </div>
                          <p className="text-[1.6rem] font-medium text-gray-800 leading-snug break-keep">
                            다양한 혜택 제공으로
                            <br />
                            전환율 증대 <span className="text-std-purple font-medium">↑</span>
                          </p>
                        </div>

                        <div className="flex flex-col items-center justify-center px-4">
                          <div className="w-[80px] h-[80px] bg-[#EEF1F4] rounded-full flex items-center justify-center mb-6">
                            <span className="material-icons-round text-[3.5rem] text-std-purple">
                              forum
                            </span>
                          </div>
                          <p className="text-[1.6rem] font-medium text-gray-800 leading-snug break-keep">
                            양방향 소통을 통한
                            <br />
                            고객 충성도 강화 <span className="text-std-purple font-medium">↑</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 3. RCS 차세대 메시징 서비스 섹션 */}
        <section className="w-full relative overflow-hidden bg-white about:mb-[2rem] px-[2rem] wide:px-0">
          {/* [배경 이미지] */}
          <div className="absolute inset-0 flex justify-center items-center pointer-events-none z-0">
            <div className="w-full max-w-container flex justify-center items-center ">
              <img
                src="/img/service-provide/messaging/rcs_bg_01.png"
                alt="RCS Background"
                className="w-auto h-auto max-w-full opacity-80"
              />
            </div>
          </div>

          {/* [콘텐츠 레이어] */}
          <div className="mx-auto max-w-container px-4 relative z-10">
            <div className="flex flex-col lg:flex-row gap-20 mb-8">
              {/* 왼쪽 설명 영역 */}
              <div className="flex-1 flex flex-col max-w-[700px]">
                <h2 className="flex flex-col md:flex-row gap-3 md:items-end font-bold mb-8">
                  <span className="text-[3.5rem] md:text-[4.2rem] text-[#06B6D4] leading-none font-black ">
                    RCS
                  </span>
                  <span className="text-[2.4rem] text-std-black font-bold">
                    차세대 메시징 서비스
                  </span>
                </h2>

                <p className="text-[1.8rem] md:text-[2rem] text-gray-700 leading-[1.6] mb-10 break-keep">
                  기본 메시지 앱에서 경험하는 스마트한 양방향 소통 서비스입니다. <br />
                  <span className="font-semibold text-std-black">
                    고화질 이미지와 다양한 템플릿
                  </span>
                  을 통해 메시지로 브랜드 경험을 선사하세요.
                </p>

                {/* 핵심 기능*/}
                <div className="w-full bg-[#06B6D4] text-white text-[1.8rem] font-bold py-6 px-10 rounded-2xl text-center mb-[1.3rem] shadow-md">
                  핵심 기능
                </div>

                {/* 기능 카드 리스트 */}
                <div className="flex flex-col gap-6">
                  {[
                    {
                      icon: "filter_frames",
                      title: "고해상도 미디어",
                      desc: "고해상도 이미지 및 동영상을 지원하여 생생한 브랜드 메시지를 전달합니다.",
                    },
                    {
                      icon: "dashboard_customize",
                      title: "통합 템플릿",
                      desc: "최대 10장의 카드 슬라이드 레이아웃 등 다양한 디자인 템플릿을 지원합니다.",
                    },
                    {
                      icon: "verified_user",
                      title: "브랜드 프로필 적용",
                      desc: "기업의 브랜드 프로필이 표시되어 스팸과 차별화 되어 신뢰도를 높입니다.",
                    },
                    {
                      icon: "phonelink_setup",
                      title: "네이티브 구동",
                      desc: "별도의 앱 설치 없이 어떤 기종이든 기본 메시지 앱에서 즉시 작동합니다.",
                    },
                  ].map((item, idx) => (
                    <div
                      key={idx}
                      className="bg-white/95 backdrop-blur-md p-4 rounded-md shadow-[0_10px_40px_rgb(0,0,0,0.08)] border border-gray-100 flex items-center gap-8 group hover:border-[#06B6D4] transition-all"
                    >
                      <div className="w-[70px] h-[70px] bg-[#E0F7FA] rounded-2xl flex items-center justify-center shrink-0 group-hover:bg-[#06B6D4] transition-colors">
                        <span className="material-icons-round text-[3.5rem] text-[#06B6D4] group-hover:text-white transition-colors">
                          {item.icon}
                        </span>
                      </div>
                      <div className="flex flex-col ">
                        <h4 className="text-[1.8rem] font-bold text-std-black mb-1">
                          {item.title}
                        </h4>
                        <p className="text-[1.6rem] text-gray-600 leading-snug break-keep">
                          {item.desc}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 4. 연동 방식 */}
        <section className="w-full px-4 -mx-4 py-[2.8rem] bg-gradient-to-r from-[#93C5FD] via-[#1E88E5] to-[#2563EB] md:-mx-8 md:px-8 lg:-mx-16 lg:px-16">
          <div className="mx-auto max-w-container">
            <div className="mb-16 text-center">
              <div className="text-[2.8rem] md:text-[3.4rem] font-bold mb-[3rem] px-[2rem]">
                <h2 className="text-white reading-tight">
                  인프라 제약 없는 우리 회사{" "}
                  <p className="relative inline">
                    맞
                    <span className="absolute block w-2 h-2 -translate-x-1/2 bg-white rounded-full -top-0.5 left-1/2" />
                  </p>
                  <p className="relative inline">
                    춤
                    <span className="absolute block w-2 h-2 -translate-x-1/2 bg-white rounded-full -top-0.5 left-1/2" />
                  </p>{" "}
                  연동 방식
                </h2>
              </div>
            </div>

            <div className="grid grid-cols-1 wide:grid-cols-3 gap-8 px-5 wide:px-0">
              {/* Agent 방식 */}
              <div className="flex flex-col gap-4 p-12 bg-white border rounded-[2rem] shadow-md max-w-[800px] mx-auto wide:max-w-none">
                <div className="flex items-center justify-between">
                  <h3 className="text-[2.8rem] md:text-[3.2rem] font-bold mb-2 leading-none">
                    Agent 방식
                  </h3>
                  <span className="material-icons-round text-[#F39325] text-[5rem] leading-none">
                    system_update_alt
                  </span>
                </div>
                <p className="text-[1.6rem] md:text-[1.8rem] break-keep text-gray-700 leading-relaxed">
                  문자를 전송하면 고객사 데이터베이스에 저장이 되고, Agent 서버로 메시지 내용을
                  전송하는 방식입니다.
                </p>
              </div>

              {/* TCP 직연동 방식 */}
              <div className="flex flex-col gap-4 p-12 bg-white border rounded-[2rem] shadow-md max-w-[800px] mx-auto wide:max-w-none">
                <div className="flex items-center justify-between">
                  <h3 className="text-[2.8rem] md:text-[3.2rem] font-bold mb-2 leading-none">
                    TCP 직연동 방식
                  </h3>
                  <span className="material-icons-round text-[#F39325] text-[5rem]  leading-none">
                    swap_calls
                  </span>
                </div>
                <p className="text-[1.6rem] md:text-[1.8rem] break-keep text-gray-700 leading-relaxed">
                  Agent 없이 고객사 서버와 자사 게이트웨이가 통신 프로토콜을 이용하여 직접 연결해
                  문자를 전달하는 방식입니다.
                </p>
              </div>

              {/* REST API 방식 */}
              <div className="flex flex-col gap-4 p-12 bg-white border rounded-[2rem] shadow-md max-w-[800px] mx-auto wide:max-w-none">
                <div className="flex items-center justify-between">
                  <h3 className="text-[2.8rem] md:text-[3.2rem] font-bold mb-2 leading-tight ">
                    REST API 방식
                  </h3>

                  <span className="material-icons-round text-[#F39325] text-[5rem] leading-none">
                    code
                  </span>
                </div>

                <p className="text-[1.6rem] md:text-[1.8rem] break-keep text-gray-700 leading-relaxed">
                  복잡한 TCP 연동 대신 표준화된 REST API를 제공하여, 별도 설치 없이 HTTP 요청만으로
                  간편하게 문자를 발송합니다.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/*  CTA 섹션  */}
      <section className="relative left-1/2 right-1/2 -mx-[50vw] w-screen bg-[#fff] py-[5rem] text-center text-white">
        <div className="mx-auto max-w-container flex flex-col items-center justify-center gap-10">
          {/* 메인 타이틀  */}
          <h2 className="text-std-black font-bold text-[2.8rem] md:text-[3.6rem] leading-[1.4] tracking-tight break-keep">
            복잡한 도입 고민은 끝, <br /> 손쉽게 경험해보고 온라인으로 서비스를 신청할 수 있습니다.
          </h2>
          <div className="flex items-center justify-center gap-4 mt-2">
            {/* 가입 후 바로 이용하기 */}
            <a
              href="/service/submit"
              className="bg-std-blue hover:bg-[#1244af] text-white text-[1.6rem] md:text-[1.8rem] font-bold px-10 py-5 rounded-md shadow-sm transition-colors inline-block text-center"
            >
              서비스 신청하기
            </a>
            {/* 이용 문의 */}
            <a
              href="/voc/submit"
              className="bg-transparent hover:bg-std-black/10 text-std-black text-[1.6rem] md:text-[1.8rem] font-medium px-10 py-5 rounded-md border border-gray-3/80 flex items-center justify-center gap-2 transition-colors inline-block text-center"
            >
              <span>이용 문의</span>
              <span className="material-icons-round text-[1.8rem] leading-none">
                arrow_forward_ios
              </span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServiceMessaging;
